import React from 'react';
import { CheckCircle2, Clock, XCircle, Circle } from 'lucide-react';

const TaskStatusBadge = ({ status }) => {
  const statusConfig = {
    pending: {
      label: 'Beklemede',
      color: 'bg-gray-100 dark:bg-gray-700 text-gray-800 dark:text-gray-200',
      icon: Circle,
      iconColor: 'text-gray-600 dark:text-gray-400'
    },
    in_progress: {
      label: 'Devam Ediyor',
      color: 'bg-blue-100 dark:bg-blue-900/30 text-blue-800 dark:text-blue-300',
      icon: Clock,
      iconColor: 'text-blue-600 dark:text-blue-400'
    },
    completed: {
      label: 'Tamamlandı',
      color: 'bg-green-100 dark:bg-green-900/30 text-green-800 dark:text-green-300',
      icon: CheckCircle2,
      iconColor: 'text-green-600 dark:text-green-400'
    },
    cancelled: {
      label: 'İptal Edildi',
      color: 'bg-red-100 dark:bg-red-900/30 text-red-800 dark:text-red-300',
      icon: XCircle,
      iconColor: 'text-red-600 dark:text-red-400'
    }
  };

  const config = statusConfig[status] || statusConfig.pending;
  const Icon = config.icon;

  return (
    <span className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-xs font-medium ${config.color}`}>
      <Icon className={`w-3 h-3 ${config.iconColor}`} />
      <span>{config.label}</span>
    </span>
  );
};

export default TaskStatusBadge;

